<ng-container *ngFor="let item of data; trackBy: trackBy">
    <tt-product-setting-mcs-form-input
        [productsettingMcKeyno]="item.productsettingmc_keyno"
        [elementtype]="item.elementtype"
        [required]="item.isrequired"
        [label]="item.field_name"
        [(model)]="item.field_value"
        (modelChange)="dataChange.emit(data)"
        [readonly]="item.protected"
        [hideCounterAfterAssign]="hideCounterAfterAssign"
        (blur)="blur.emit()"
        [data]="items[item.productsettingmc_keyno]"
    ></tt-product-setting-mcs-form-input>
</ng-container>
